import React from "react";
import { motion } from "framer-motion";

const WebinarFooter: React.FC = () => {
  return (
    <footer className="bg-white text-black py-12">
      <div className="max-w-6xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex items-center justify-center space-x-3 mb-6"
        >
          <img
            src={`${window.location.origin}/logo-zylu.webp`}
            alt="Zylu Logo"
            className="h-10"
          />
        </motion.div>
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="text-gray-600 mb-6"
        >
          Empowering salon owners to run their business on autopilot
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          viewport={{ once: true }}
          className="text-sm text-gray-500"
        >
          © 2025 Zylu. All rights reserved.
        </motion.div>
      </div>
    </footer>
  );
};

export default WebinarFooter;
